import styled from 'styled-components';

export const StageViewport = styled.div`
  position: relative;
  flex: 1;
  min-width: 0;
  display: flex;
  overflow: auto;
  padding: 24px;
  background:
    linear-gradient(45deg, #f1f1f1 25%, transparent 25%) -12px 0 / 24px 24px,
    linear-gradient(-45deg, #f1f1f1 25%, transparent 25%) -12px 0 / 24px 24px,
    linear-gradient(45deg, transparent 75%, #f1f1f1 75%) 0 0 / 24px 24px,
    linear-gradient(-45deg, transparent 75%, #f1f1f1 75%) 0 0 / 24px 24px,
    #fafafa;
`;

export const StageWrapper = styled.div`
  position: relative;
  flex: none;
  margin: auto;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);
  background-color: #ffffff;
`;

export const MenuWrapper = styled.div`
  position: absolute;
  z-index: 20;
  min-width: 176px;
  padding: 4px;
  border-radius: 8px;
  border: 1px solid #e4e4e7;
  background: #ffffff;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.16);
`;

export const MenuItem = styled.button<{ $danger?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 6px 8px;
  border-radius: 6px;
  font-size: 12px;
  text-align: left;
  color: ${({ $danger }) => ($danger ? '#c20e4d' : '#27272a')};

  &:hover {
    background: ${({ $danger }) => ($danger ? '#fdeef3' : '#f4f4f5')};
  }
`;

export const MenuSeparator = styled.hr`
  margin: 4px 0;
  border: none;
  border-top: 1px solid #f1f1f1;
`;
